"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPinoAdapter = exports.ConsoleAdapter = exports.createLogger = void 0;
var logger_1 = require("./logger");
Object.defineProperty(exports, "createLogger", { enumerable: true, get: function () { return logger_1.createLogger; } });
var adapters_1 = require("./adapters");
Object.defineProperty(exports, "ConsoleAdapter", { enumerable: true, get: function () { return adapters_1.ConsoleAdapter; } });
Object.defineProperty(exports, "createPinoAdapter", { enumerable: true, get: function () { return adapters_1.createPinoAdapter; } });
//# sourceMappingURL=index.js.map